import { z } from "zod";
/** Verbatim eClaim container strings (`ValidContainerLegacy` VALUES, not keys) — canonical end-to-end, no boundary map (ADR-0003). */
export const incidentContainer = {
    ACCIDENT_PARTNERS: "ACCIDENT_PARTNERS",
    AUTOMATIC: "AUTOMATIC",
    BILLS: "BILLS",
    COMMISSIONED_EXPERT_REPORT: "COMMISSIONED_EXPERT_REPORT",
    COMPLAINT: "COMPLAINT",
    DAMAGE: "DAMAGE",
    DIAC: "DIAC",
    DRIVER_LICENSE: "DRIVER_LICENSE",
    E_CASE: "E_CASE",
    ESTIMATE: "ESTIMATE",
    EVENT_LOCATION: "EVENT_LOCATION",
    EXPERT_REPORT: "EXPERT_REPORT",
    EXTERNAL_EVENT_NUMBER: "EXTERNAL_EVENT_NUMBER",
    INCIDENT_DATE: "INCIDENT_DATE",
    INSURANCE_DATA_IMPORT: "INSURANCE_DATA_IMPORT",
    LAWYER: "LAWYER",
    LAWYER_BILLING: "LAWYER_BILLING",
    LEGAL_ACTION: "LEGAL_ACTION",
    PARTIAL_MISAPPROPRIATION: "PARTIAL_MISAPPROPRIATION",
    POLICE_REPORT: "POLICE_REPORT",
    RENTAL_CAR: "RENTAL_CAR",
    REPAIR_CONTROL: "REPAIR_CONTROL",
    REPAIR_PROCEDURE: "REPAIR_PROCEDURE",
    REPAIR_SERVICE: "REPAIR_SERVICE",
    REQUIREMENTS: "REQUIREMENTS",
    TOTAL_LOSS: "TOTAL_LOSS",
    TOTAL_THEFT: "TOTAL_THEFT",
    TOWING: "TOWING",
    TRAILER: "TRAILER",
    WITNESSES_AND_CASUALTIES: "WITNESSES_AND_CASUALTIES",
};
export const incidentContainerSchema = z.enum(incidentContainer);
